import React, { PropTypes, Component } from 'react'
import { Link } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import FaDiamond from 'react-icons/lib/fa/diamond'
import Arrow from 'react-icons/lib/io/android-arrow-forward';
import RippleLink from '../../../ripplelink';
import style from './style.css';
import withHomeResorts from '../../../../containers/homeresorts';
import withMedia from '../../../../containers/withmedia';
import withPager from '../../../../lib/pager';
import Fade from '../../../pagescreen/fade';
import SectionTitle from '../../../resorthome/sectiontitle';

const CardItem = ({card}) => {
    const photo_uri = card.photo && card.photo.photo_uri
    const grand = (/Grand/i).test(card.url)
    return (
        <div className={ style.innerSlide }>
            <div className={ style.img } style={ { backgroundImage: `url('https://www.sunrise-resorts.com${ photo_uri.replace("medium","gallery") }')` }}  > 
            </div>
            <Fade styles={ { position: 'absolute', zIndex: 1, height: "50%" } }/>
            <img src={ `https://www.sunrise-resorts.com/images/logos/logo_white_${card.url.split("/")[card.url.split("/").length-1] }.svg` } className={ style.logo }/>
            <div className={ style.textBox }>
                <div className={ [ style.itemTitle, grand ? style.textGold : style.textTurquoise ].join(" ") }>
                    <div className={ style.title }>
                        <span>{ card.title }</span> 
                        <span> { grand ? <FaDiamond className={style.iconDiamond }/> : ' ' } </span>
                    </div>
                    <div className={ style.blurb }>
                        { card.blurb }
                    </div> 
                </div>
                <div className={ style.price }>Rooms Starting from <span>${ card.room_price }</span> PR/PN
                </div>
                <div className={ style.arrow }>
                    <Arrow/>
                </div>
            </div>
        </div>
    )
}
class ScrollingResorts extends Component {

    _current_slide(idx, idxlatest){
        const { pager } = this.props
        if('goto' in pager) { pager.goto(idx) }
    }
    render() {
        const { items, title, current } = this.props
        let slides = []
        slides = items
            ? Object.keys(items).map( (k) => 
            <div key={items[k].id} className={ `${style.slide}` } >
                <RippleLink url={`${items[k].url}`} styles={{ flex:1, display:'flex'}}>
                    <CardItem card={items[k]} />
                </RippleLink>
            </div>
                ) 
            : <div></div>;
        return (
            <div className={ style.resorts }>
                <SectionTitle title={ "SUNRISE Resorts" }/>
                <h4 className={ style.subtitle }>{ this.props.title }</h4>
                    {items &&
                    <div>
                        <SwipeableViews className={ style.slider } onChangeIndex={ (idx, latest) => this._current_slide(idx, latest) } enableMouseEvents={ false }>
                            {slides}
                        </SwipeableViews>
                        <div className={ style.dotnav}>
                            { slides && slides.map( ( e , i ) => 
                            <div className={ i == current ? style.activeDot : style.inactiveDot }></div>
                            )
                            }
                        </div>
                    </div>
                    }
            </div>
        )
    }
}
                // <ScrollBox style={{height: '200px'}} axes={ScrollAxes.X} fastTrack={FastTrack.PAGING}>
                // </ScrollBox>


export default withPager(withMedia(withHomeResorts(ScrollingResorts)))



// WEBPACK FOOTER //
// ./src/components/homescreen/resorts/sliderresorts/index.js